import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { handleTicketArea } from "../../../../../../store/ticketsOperatorArea/actions";

import "./style.scss";

function ButtonTicketList({ isSpy, resetActiveChat }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isOpen = useSelector((state) => state.TicketsOperatorArea.isOpen);
  const permissionsExtra =
    useSelector((state) => state.Login?.data?.permissions_extra) || {};

  const handleChange = useCallback(() => {
    dispatch(handleTicketArea(!isOpen));
    resetActiveChat();
  }, [dispatch, isOpen, resetActiveChat]);

  if (!permissionsExtra?.tickets_operator_area) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn-custom waves-effect btn-light w-100 mb-2"
      variant={isOpen ? "contained" : "outlined"}
      onClick={handleChange}
      disabled={isSpy}
    >
      {isOpen ? t("Back to Attendance") : t("Search Tickets")}
    </button>
  );
}

export default memo(ButtonTicketList);
